import { Navigate, Route, Routes } from 'react-router-dom'
import ScrollToTop from './components/site/ScrollToTop'
import { SessionProvider } from './lib/session'
import UtilityBanner from './components/site/UtilityBanner'
import SiteHeader from './components/site/SiteHeader'
import SiteFooter from './components/site/SiteFooter'
import HomePage from './pages/HomePage'
import ParticipantPage from './pages/ParticipantPage'
import AdminPage from './pages/AdminPage'

export default function App() {
  return (
    <SessionProvider>
    <div className="flex min-h-dvh flex-col">
      <ScrollToTop />
      <a
        href="#main"
        className="sr-only focus:not-sr-only focus:absolute focus:z-50 focus:m-2 focus:rounded focus:bg-[var(--page-canvas)] focus:px-4 focus:py-2 focus:font-semibold"
      >
        Skip to main content
      </a>
      <UtilityBanner />
      <SiteHeader />
      <main id="main" className="flex flex-1 flex-col">
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/participant" element={<ParticipantPage />} />
          <Route path="/admin/*" element={<AdminPage />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </main>
      <SiteFooter />
    </div>
    </SessionProvider>
  )
}
